import {
  Box,
  Button,
  Container,
  Group,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";
import Image from "next/image";
import { useTranslations } from "next-intl";
import ButtonSupport from "@/components/ButtonSupport";
import { AlertError } from "@/components/ui/Alert";
import errorImage from "@/components/ui/error-500.png";

export default function ServerError({ reset }: { reset: () => void }) {
  const t = useTranslations("components.ui.ServerError");

  return (
    <Container size="md" py="xl">
      <AlertError>
        <Stack align="center" gap="lg">
          <Title order={1}>{t("title")}</Title>

          <Box>
            <Text size="lg" ta="center">
              {t("message1")}
            </Text>

            <Text size="lg" ta="center">
              {t("message2")}
            </Text>
          </Box>

          <Group>
            <Button
              leftSection={<IconRefresh size={16} />}
              onClick={() => reset()}
              variant="filled"
            >
              {t("tryAgain")}
            </Button>
            <ButtonSupport variant="light" />
          </Group>
        </Stack>
      </AlertError>

      <Image src={errorImage} alt="Error" />
    </Container>
  );
}
